import { observer } from 'mobx-react-lite'
import { useEffect, Fragment } from 'react'
import './index.css'
import {
  Button,
  Col,
  ConfigProvider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Table,
  Tag,
  Progress
} from 'antd'
import { CommonStore, CallManageStore } from '../../../store'
import RowDetail from './rowDetail'
import Details from './details_manage'
function CallManage() {
  const [form] = Form.useForm()
  const { Column } = Table
  const { Option } = Select

  useEffect(() => {
    form.setFieldsValue({
      taskId: null,
      taskName: null,
      taskStatus: [],
      taskScript: null,
    })
    resetSearchBth()
  }, [])

  const getFormData = (changeValue: any, allValues: any) => {
    CallManageStore.setSearchForm({ ...allValues })
  }
  // 搜索
  const searchBtn = () => {
    CallManageStore.resetPage()
    CallManageStore.getTaskPage()
  }
  //重置
  const resetSearchBth = () => {
    CallManageStore.setSearchForm({})
    searchBtn()
  }
  //新建任务/编辑
  const addPower = (data?: any) => {
    if (data) {
      CallManageStore.getTaskInfo(data);
    } else {
      CallManageStore.addOrUpdateModal.open("add");
      // CallManageStore.phoneList = []
      CallManageStore.disTime[0] = false
      CallManageStore.numberPoolNo =''
    }
  };
  return (
    <Fragment>
      <RowDetail></RowDetail>
      <Details></Details>
      <div className="allContent">
        <div className="formContent">
          <Form
            form={form}
            initialValues={CallManageStore.searchForm}
            autoComplete="off"
            labelCol={{ span: 6 }}
            onValuesChange={getFormData}
            onKeyDown={(e) => {
              if (e.key.toLowerCase() === 'enter') {
                searchBtn()
              }
            }}
          >
            <Row justify="start">
              <Col span={8}>
                <Form.Item label="任务ID" name="taskId">
                  <Input placeholder="请输入任务ID" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="任务名称" name="taskName">
                  <Input placeholder="请输入任务名称" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="任务状态" name="taskStatus">
                  <Select style={{ width: '98%' }} mode="multiple">
                    <Option value={0}>未开始</Option>
                    <Option value={1}>进行中</Option>
                    <Option value={2}>任务结束</Option>
                    <Option value={3}>手动暂停</Option>
                    <Option value={4}>工作时间暂停</Option>
                    <Option value={5}>禁呼中</Option>
                    <Option value={6}>拨打完成</Option>
                    <Option value={7}>任务终止</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="话术" name="taskScript">
                  <Select
                    allowClear={true}
                    placeholder="请选择话术"
                    showSearch
                    optionFilterProp="label"
                    options={
                      CallManageStore.getAllbotList &&
                      CallManageStore.getAllbotList.map((item: any) => ({
                        value: item.botNameEn,
                        label: item.botName
                      }))
                    }
                  ></Select>
                </Form.Item>
              </Col>
              <Col offset={2}>
                <Form.Item>
                  <Space>
                    <Button type="primary" onClick={searchBtn}>
                      搜索
                    </Button>
                    <Button htmlType="reset" onClick={resetSearchBth}>
                      重置
                    </Button>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={8} offset={16}>
                <Button
                  onClick={() => addPower()}
                  type="primary"
                  style={{ float: 'right', marginBottom: '10px' }}
                >
                  新建任务
                </Button>
              </Col>
            </Row>
          </Form>
          <ConfigProvider renderEmpty={CommonStore.tableEmptyRender}>
            <Table
              dataSource={CallManageStore.tableData.records}
              rowKey={(record) => record.no}
              loading={CallManageStore.tableLoad}
              scroll={{ x: 1300 }}
              pagination={{
                current: CallManageStore.pageData.page,
                pageSize: CallManageStore.pageData.size,
                onChange: CallManageStore.pageData.changePage,
                pageSizeOptions: [10, 20, 50, 100],
                showSizeChanger: true,
                total: CallManageStore.tableData.total,
                showTotal: () =>
                  `共计${CallManageStore.tableData.total}条`,
                position: ["bottomLeft"],
              }}
            >
              <Column
                fixed="left"
                ellipsis={true}
                width={150}
                title="任务名称"
                dataIndex="taskName"
              />
              <Column
                fixed="left"
                title="任务ID"
                width={150}
                dataIndex="taskId"
                ellipsis={true}
              />
              <Column
                title="任务进度"
                width={150}
                dataIndex="finishRate"
                ellipsis={true}
                render={(finishRate) =>
                  <Progress percent={Math.round(finishRate * 100)}/>
                }
              />
              <Column
                title="任务状态"
                width={150}
                dataIndex="taskStatus"
                ellipsis={true}
                render={(taskStatus) => {
                  if (taskStatus == "0") {
                    return <Tag color="gold">未开始</Tag>;
                  } else if (taskStatus == "1") {
                    return <Tag color="green">进行中</Tag>;
                  } else if (taskStatus == "2") {
                    return <Tag color='default'>任务结束</Tag>;
                  }else if (taskStatus == "3") {
                    return <Tag>手动暂停</Tag>;
                  }else if (taskStatus == "4") {
                    return <Tag>工作时间暂停</Tag>;
                  }else if (taskStatus == "5") {
                    return <Tag>禁呼中</Tag>;
                  }else if (taskStatus == "6") {
                    return <Tag color='blue'>拨打完成</Tag>;
                  }else if (taskStatus == "7") {
                    return <Tag color='default'>任务终止</Tag>;
                  }
                }}
              />
              <Column
                title="开始时间"
                width={170}
                dataIndex="startTime"
                ellipsis={true}
              />
              <Column
                title="结束时间"
                width={170}
                dataIndex="endTime"
                ellipsis={true}
              />
              <Column
                title="名单数"
                width={150}
                dataIndex="listSize"
                ellipsis={true}
              />
              <Column
                title="呼叫数"
                width={150}
                dataIndex="calledSize"
                ellipsis={true}
              />
               <Column
                title="接通数"
                width={150}
                dataIndex="throughSize"
                ellipsis={true}
              />
              <Column
                title="接通率"
                width={150}
                dataIndex="throughRate"
                ellipsis={true}
                render={(throughRate) =>
                 `${Math.round(throughRate * 100)}%`
                }
              />
              <Column
                title="完成率"
                width={150}
                dataIndex="finishRate"
                ellipsis={true}
                render={(finishRate) =>
                  `${Math.round(finishRate * 100)}%`
                }
              />
              <Column
                width={240}
                title="操作"
                fixed={"right"}
                align={"left"}
                render={(text: string, record: any) => (
                  <Space>
                    {CommonStore.pagePermission.readable && (
                      <Button
                        size={"small"} 
                        onClick={() =>
                          CallManageStore.onOpenDetail(record)
                        }
                      >
                        详情
                      </Button>
                    )}
                     {CommonStore.pagePermission.readable && (
                      <Button size={"small"} onClick={() => addPower(record)}
                      disabled={[2, 7, 1].includes(record.taskStatus)}>
                      编辑
                    </Button>
                    )}
                    {CommonStore.pagePermission.readable && (record.taskStatus!=3 && record.taskStatus!=4) && (
                      <Button
                      size={"small"} 
                      disabled={record.taskStatus==2 ||record.taskStatus==7 ||record.taskStatus==0}
                      onClick={() =>
                        CallManageStore.setTaskStatus(record,0)
                      }
                    >
                      暂停
                    </Button>
                    )}
                    {CommonStore.pagePermission.readable && (record.taskStatus== 3 || record.taskStatus== 4)  &&(
                       <Button
                       size={"small"} 
                       onClick={() =>
                        CallManageStore.setTaskStatus(record,1)
                       }
                     >
                       启动
                     </Button>
                    )}
                     {CommonStore.pagePermission.readable && (
                      <Button
                        size={"small"} 
                        disabled={record.taskStatus==2 || record.taskStatus==7}
                        onClick={() =>
                          CallManageStore.setTaskStatus(record,2)
                        }
                      >
                        终止
                      </Button>
                    )}
                  </Space>
                )}
              />
            </Table>
          </ConfigProvider>

        </div>
      </div>
    </Fragment>
  )
}
export default observer(CallManage)
